import { createAsyncThunk } from '@reduxjs/toolkit';
import { $api } from 'shared/api';
import { formatDate } from 'shared/helpers';
import { IEditModalSchema } from '../../modal/model/types/editModalSchema';
import { getUpdatedProjectsForFilter } from '../lib/getUpdatedProjectsForFilter/getUpdatedProjectsForFilter';
import { tasksInformationActions } from '../model/slice/tasksInformation';

interface FetchTasksError {
    message: string;
}

interface TaskPayload extends IEditModalSchema {}

export const updateCustomTask = createAsyncThunk<
    any,
    TaskPayload,
    { rejectValue: FetchTasksError }
>('tasks/updateCustomTask', async (taskPayload, thunkApi) => {
    //@ts-ignore
    const url = routable.getRoute('updateTask');
    const {
        title,
        tags,
        dateEnd,
        dateStart,
        color,
        description,
        estimateId,
        isCompleted,
        executorId,
        observerIds,
        projectId,
        status,
        taskUid,
        entityUid,
        attachments,
    } = taskPayload;

    const is_completed = isCompleted ? 1 : 0; // для бд нужно 1 или 0
    const formData = new FormData();

    const dateEndIsNotNull = dateEnd === null || dateEnd.length === 1 ? 'Invalid date' : dateEnd;
    const formattedDate = formatDate(dateEndIsNotNull, 'YYYY-MM-DD');

    if (tags.length > 0) {
        tags.forEach((tag) => formData.append('tags[]', tag));
    }
    if (observerIds && observerIds.length > 0) {
        observerIds.forEach((obs) => formData.append('observer_ids[]', JSON.stringify(obs)));
    }

    if (attachments?.length > 0) {
        const noIncluded = attachments.every((att) => att?.file);
        if (noIncluded) formData.append('included_attachments[]', '');
        attachments.forEach((attach) => {
            if (attach?.file) {
                formData.append('new_attachments[]', attach?.file);
            } else {
                formData.append('included_attachments[]', String(attach?.id));
            }
        });
    } else {
        formData.append('included_attachments[]', '');
    }

    // если исполнителя изменили на "не выбрано"
    const executorIdToFormData = !executorId ? '' : (executorId as string);

    formData.append('title', title);
    formData.append('date', formattedDate);
    formData.append('color', color);
    formData.append('description', description);
    formData.append('estimate_id', !estimateId ? '' : (estimateId as string));
    formData.append('is_completed', JSON.stringify(is_completed));
    formData.append('executor_id', executorIdToFormData);
    formData.append('project_id', !projectId ? '' : (projectId as string));
    formData.append('status', status);

    try {
        const formattedUrl = url.replace('_customTask_', entityUid);
        const response = await $api.post<any>(`${formattedUrl}`, formData);

        const state = thunkApi.getState();
        //@ts-ignore
        const { projectsForFilter, projects } = state.tasksInformationReducer;
        const updatedProjectsForFilter = getUpdatedProjectsForFilter(
            projectId,
            estimateId,
            projectsForFilter,
            projects
        );
        if (!!updatedProjectsForFilter) {
            thunkApi.dispatch(
                tasksInformationActions.updateProjectsForFilter(updatedProjectsForFilter)
            );
        }

        return {
            task: response.data.data.task,
            newTabs: response.data.data.new_tabs,
            newTags: response.data.data.new_tags,
        };
    } catch (error) {
        return thunkApi.rejectWithValue(
            error.response?.data || {
                message: 'Неизвестная ошибка',
            }
        );
    }
});
